export default () => ({
	credit_card: null,
	full_name: null,
	tax_number: null,
	company: null,
	contact: null
})